import { InitFeatureParams } from '../types'
import { getRoutes, modalRoutes } from './routes'

export const initActivities = ({ addRoutes }: InitFeatureParams) => {
  addRoutes(getRoutes(), modalRoutes)
}
